import cloneDeep from 'lodash/cloneDeep';
import {setFormDataMerge} from './redux/appState'
import {databaseViewApi} from './redux/databaseView';


export function removeNonInstanceVariables(schema,data,cleanObj)
	{
	if (cleanObj===undefined)
		cleanObj={};
//	console.log("bj1",schema);
	schema.components.forEach((x)=>
		{
		if (x.key&&data[x.key]!==undefined)
			{
			cleanObj[x.key]=data[x.key];
//			console.log(x.key);
			}
		if (x.components&&!x.properties?.readOnly)			//don't save any groups where the whole group is marked as readonly
			removeNonInstanceVariables(x,data,cleanObj);
		if (!!x.properties?.tableIndex)
			{
			cleanObj[x.properties.tableIndex]=data[x.properties.tableIndex];
			console.log(x.properties.tableIndex);
			}
		else if (!!x.properties?.tableKey)
			{
			cleanObj[x.properties.tableKey]=data[x.properties.tableKey];
//			console.log(x.properties.tableKey);
			}
		})
	return cleanObj;
	}

export async function saveFormInstance(processState, data, instanceID, activeState,  publishAndNext,publishProcessInstanceData)
	{
	var processName=processState.processName;
	var savedData={...data};
	//removeNonInstanceVariables(processState.schema,savedData);
	
	for (const entry in savedData)
		{
		if (entry.toUpperCase().startsWith("ZZ"))
			delete savedData[entry];
		}	
	const itemReference="instance"+instanceID+activeState;
	console.trace()
	if (publishAndNext)
		{	//we probably should take this as the main data source of truth as it takes from other stations
		var instanceData=removeNonInstanceVariables(processState.schema,savedData);
		var publishData=await publishProcessInstanceData({data:instanceData,instance:instanceID,state:activeState,name:processName});
		if (publishData.data?.success)
			{
			savedData[" version"]=publishData.data.data[" version"];
			savedData[" executionID"]=publishData.data.data[" executionID"];
			}
		}
		
	localStorage.setItem(itemReference,JSON.stringify(savedData));
	return savedData;
	}

export async function loadFormInstanceData(dispatch,instanceID,stateID)
	{
	const itemReference="instance"+instanceID+stateID;
	var savedData=localStorage.getItem(itemReference);

	try
		{
		savedData=savedData?JSON.parse(savedData):null;
		}
	catch (e)
		{
		console.warn("Unable to parse locally saved form data",itemReference,e);
		savedData=null;
		}

	dispatch(setFormDataMerge(null));

	async function loadServerData()
		{
		console.log("loadServerData");
		var serverData=await dispatch(
			databaseViewApi.endpoints.loadCurrentInstanceStateData.initiate({stateID,instanceID})
			);

		if (!serverData.data?.success)
			return null;

		serverData=serverData.data.data;

		if (!serverData?.id)
			return null;

		var id=parseInt(serverData.id);
		serverData={...serverData.data};
		serverData[" version"]=id;

		return serverData;
		}

	if (false&&savedData)
		{
		loadServerData().then((serverData)=>
			{
			if (!serverData)
				return;

			if (savedData[" version"]&&savedData[" version"]!==serverData[" version"])
				dispatch(setFormDataMerge(cloneDeep(serverData)));
			})
			.catch((e)=>
			{
			console.error("Unable to load server form data",e);
			});

		return savedData;
		}
	
	var serverData=await loadServerData();

	return serverData?cloneDeep(serverData):{};
	}
